module.exports = __webpack_public_path__ + "img/lvshi_lv_sample1.bec71cd1.png";